// extracted by mini-css-extract-plugin
var _1 = "button__JdfMU";
var _2 = "container__ZBm8e";
export { _1 as "button", _2 as "container" }
export default { "button": _1, "container": _2 }
